module.exports = __webpack_public_path__ + "static/media/module-2000.1ae6f8e0.svg";